import React from 'react';

const PoliticaPrivacidade = () => {
  return (
    <div className="legal-page">
      <h1><strong>Política de Privacidade</strong></h1>
      
      <p>
        A Soluções valoriza a sua privacidade e está comprometida em proteger os dados que você nos fornece. Esta política descreve como coletamos, usamos e protegemos suas informações.
      </p>

      <h2><strong>1. Coleta de Dados</strong></h2>
      <p>
        Nossa landing page é <strong>somente informativa</strong> e não realiza vendas online. Coletamos informações estritamente necessárias para comunicação e aprimoramento do atendimento em nossa loja física.
      </p>
      <ul>
        <li><strong>Formulário de Contato:</strong> Coletamos nome, telefone e mensagem.</li>
        <li><strong>Finalidade:</strong> Usamos esses dados exclusivamente para entrar em contato com o usuário via WhatsApp, responder dúvidas ou agendar visitas à loja física.</li>
        <li><strong>Dados de Navegação:</strong> Podemos coletar dados anônimos de uso do site (via ferramentas como Google Analytics) para entender o comportamento do usuário e melhorar a experiência da página.</li>
      </ul>

      <h2><strong>2. Uso e Compartilhamento</strong></h2>
      <p>
        Suas informações <strong>não são vendidas, alugadas ou trocadas</strong> com terceiros para fins comerciais. O telefone fornecido é utilizado unicamente para iniciar a conversa via WhatsApp, visando o atendimento.
      </p>

      <h2><strong>3. Segurança</strong></h2>
      <p>
        Tomamos medidas de segurança razoáveis para proteger suas informações contra acesso não autorizado ou divulgação.
      </p>

      <h2><strong>4. Links Externos</strong></h2>
      <p>
        Nossa página pode conter links para redes sociais e WhatsApp. Ao clicar neles, você estará sujeito às políticas de privacidade dessas plataformas, e a Soluções não se responsabiliza por suas práticas de coleta de dados.
      </p>

      <p className="update-date">
        Última atualização: Outubro de 2025
      </p>
    </div>
  );
};

export default PoliticaPrivacidade;